import { render, staticRenderFns } from "./newReference.vue?vue&type=template&id=25b887e6&scoped=true"
import script from "./newReference.vue?vue&type=script&lang=js"
export * from "./newReference.vue?vue&type=script&lang=js"
import style0 from "./newReference.vue?vue&type=style&index=0&id=25b887e6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b887e6",
  null
  
)

export default component.exports